import { render, staticRenderFns } from "./TaskGroups.vue?vue&type=template&id=1717ed25"
import script from "./TaskGroups.vue?vue&type=script&lang=js"
export * from "./TaskGroups.vue?vue&type=script&lang=js"
import style0 from "./TaskGroups.vue?vue&type=style&index=0&id=1717ed25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports